import React from 'react';
import * as util from '#packages/util';
import _ from 'lodash';
import {
  mapStateToProps,
  mapDispatchToProps,
  type PublishPanelDispatchProps,
  type PublishPanelStateProps,
} from './publishPanelMappers';

import TextAndLinkPanel from '../textAndLinkPanel';
import {
  withPanelData,
  type PublishPanelWithPanelDataProps,
} from './publishPanelStructure';
import CustomTemplateTextAndLinkPanel from '../customTemplateTextAndLinkPanel/textAndLinkPanel';
import {
  CUSTOM_TEMPLATE_PUBLISH_PANEL_DATA_CONFIG,
  CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS,
} from '../customTemplateTextAndLinkPanel/textAndLinkPanelDataConfig';

const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;

export interface PublishPanelOwnProps {}

export interface PublishPanelProps
  extends PublishPanelDispatchProps,
    PublishPanelWithPanelDataProps,
    PublishPanelStateProps,
    PublishPanelOwnProps {}

const PublishPanel = (props: PublishPanelProps) => {
  if (props.isCustomTemplate) {
    const customTemplatePanelData = props.isCustomTemplatePublished
      ? CUSTOM_TEMPLATE_PUBLISH_PANEL_DATA_CONFIG[
          CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS.SITE_POST_PUBLISH
        ]
      : CUSTOM_TEMPLATE_PUBLISH_PANEL_DATA_CONFIG[
          CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS.SITE_PRE_PUBLISH
        ];

    return (
      <CustomTemplateTextAndLinkPanel
        customTemplatePanelData={customTemplatePanelData}
        editorAPI={props.editorAPI}
      />
    );
  }

  return <TextAndLinkPanel panelData={props.panelData} />;
};

const ConnectedPublishPanel = _.flow(
  withPanelData,
  connect(EDITOR_API, mapStateToProps, mapDispatchToProps),
)(PublishPanel);

export default ConnectedPublishPanel;
